<template>
  <v-card id="create" class=" pb-lg-0 elevation-0">
    
    <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
      class="pb-0 mt-12"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="rgb(88, 183, 230)"
          dark
          fab
          class=""
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <div v-else>
            <v-img src="../../../assets/images/LevelTest/more-white.svg" aspect-ratio="1" max-height="100" contain/>
          </div>
        </v-btn>
      </template>
     <a href="https://pf.kakao.com/_xdKxhul/chat" target="_blank"> <v-btn
        fab
        dark
        medium
        color="rgb(255, 235, 59)"
      >
         <v-img src="../../../assets/images/LevelTest/kakao-talk.svg" aspect-ratio="1" max-height="35" contain/>
      </v-btn> </a>
     
     <a href="https://megatalking.co.kr/enrollment" target="_blank"> <v-btn
        fab
        dark
        medium
        color="white"
      >
         <v-img src="../../../assets/images/LevelTest/enroll.svg" aspect-ratio="1" max-height="35" contain/>
      </v-btn> </a>

    </v-speed-dial>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'scale-transition',
    }),

    

    watch: {
      top (val) {
        this.bottom = !val
      },
      right (val) {
        this.left = !val
      },
      bottom (val) {
        this.top = !val
      },
      left (val) {
        this.right = !val
      },
    },
  }
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  #create .v-speed-dial {
    position: fixed;
  }

  #create .v-btn--floating {
    position: relative;
  }
</style>